module.exports = __webpack_public_path__ + "static/media/ico-tarjeta_0002_american.ac876f8a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imagenes/checkout/payment-options/ico-tarjeta_0002_american.jpg
// module id = 126
// module chunks = 0